import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import Input from 'components/Input';

const SurveyListSearch = ({ onSubmit }) => {
  const { t } = useTranslation();
  const [keyword, setKeyword] = useState('');

  return (
    <>
      <div aria-labelledby="search-form" className="mt-6">
        <div className="w-1/3 relative">
          <Input
            type="search"
            value={keyword}
            allowClear={true}
            onClickClear={() => {
              setKeyword('');
              onSubmit('');
            }}
            onClickSearch={() => {
              onSubmit(keyword);
            }}
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                onSubmit(keyword);
              }
            }}
            onChange={(e) => {
              if (e.target.value === '' && keyword !== '') {
                onSubmit('');
              }
              setKeyword(e.target.value);
            }}
            placeholder={t('PLACE_SEARCH_SURVEY')}
          />
        </div>
      </div>
    </>
  );
};

export default React.memo(SurveyListSearch);
